export default __webpack_public_path__ + "static/img1AR-3cf81da5034ed3ca9e5e972ac63a6cba.png";